import useAuth from 'hooks/useAuth';
import { useState } from 'react';

import { Box, Tooltip } from '@mui/material';
import ChooseActiveDeployment from './dialogs/ChooseActiveDeployment';
import { DEFAULT_LOGO_URL } from 'constants';
import DeploymentLogoImage from './components/DeploymentLogoImage';

const SelectDeploymentSection = () => {
    const { deployments = [] } = useAuth();
    const [deployment] = useState(localStorage.getItem('active-deployment') || '');
    const logo = deployments?.find((item) => item.deployment === deployment)?.logo;
    const [openModal, setOpenModal] = useState({
        chooseActiveDeployment: false
    });

    return (
        <Box
            sx={{
                ml: 2
            }}
        >
            <Tooltip title="Click to select client deployment">
                <Box
                    sx={{ cursor: 'pointer' }}
                    onClick={() =>
                        setOpenModal({
                            ...openModal,
                            chooseActiveDeployment: true
                        })
                    }
                >
                    <DeploymentLogoImage alt={deployment || ''} src={logo || DEFAULT_LOGO_URL} />
                </Box>
            </Tooltip>
            {openModal.chooseActiveDeployment && (
                <ChooseActiveDeployment
                    toggleDialog={openModal.chooseActiveDeployment}
                    onClose={() =>
                        setOpenModal({
                            ...openModal,
                            chooseActiveDeployment: false
                        })
                    }
                />
            )}
        </Box>
    );
};

export default SelectDeploymentSection;
